import { IconStatus, Text, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { SecuritiesTransferListItemNormalized } from '../../../../../../../../../store/customerDetail/SecuritiesTransfer/types';

interface TableContentItemStatusProps {
  statusIcon: SecuritiesTransferListItemNormalized['statusIcon'];
  status: string;
}

export const TableContentItemStatus: React.FC<TableContentItemStatusProps> = ({
  statusIcon,
  status,
}: TableContentItemStatusProps) => {
  return (
    <HStack alignItems="center" space={Spacing['inline.quarck']}>
      <IconStatus
        testId="icon-status"
        icon={statusIcon.icon}
        bgColor={statusIcon.bgColor}
        color={statusIcon.color}
        size={statusIcon.size || 'xs'}
      />
      <Text
        color="neutral.black"
        variant="regular"
        fontSize={Typography['fontsize.md']}
        noOfLines={1}
        textTransform="uppercase">
        {status}
      </Text>
    </HStack>
  );
};
